import { render, staticRenderFns } from "./question-detail.vue?vue&type=template&id=00d224df&scoped=true&"
import script from "./question-detail.js?vue&type=script&lang=js&"
export * from "./question-detail.js?vue&type=script&lang=js&"
import style0 from "./question-detail.scss?vue&type=style&index=0&id=00d224df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d224df",
  null
  
)

export default component.exports